<script lang="ts" setup>
const { getActionAttributes, getMetaAttributes } = useApiAttributes()
const { t } = useI18n()

const endpoints: ApiEndpoint[] = [
  {
    method: 'GET',
    path: '/actions',
  },
]

const queryAttributes: ApiAttribute[] = [
  {
    description: t('attributes.full'),
    example: false,
    name: 'full',
    optional: true,
    type: 'boolean',
  },
  {
    description: t('attributes.ids'),
    example: [1, 2],
    name: 'ids',
    optional: true,
    type: 'array',
  },
  {
    description: t('attributes.listId'),
    example: 1,
    name: 'listId',
    optional: true,
    type: 'number',
  },
  {
    description: t('attributes.page'),
    example: 1,
    name: 'page',
    optional: true,
    type: 'number',
  },
  {
    description: t('attributes.size'),
    example: 10,
    name: 'size',
    optional: true,
    type: 'number',
  },
  {
    description: t('attributes.status'),
    name: 'status',
    optional: true,
    type: 'string',
    values: [
      'pending',
      'completed',
      'active',
      'failed',
    ],
  },
]

const response = {
  actions: [
    {
      cost: 10,
      createdAt: '2024-08-23T17:02:47.296+02:00',
      id: 42,
      status: 'pending',
      type: 'jobs:request',
      updatedAt: '2024-08-23T17:02:47.296+02:00',

      data: {
        domains: ['pearson.com'],
        job: 'enrich-companies',
      },
    },
    {
      cost: 10,
      createdAt: '2024-08-23T17:02:40.000+02:00',
      id: 40,
      status: 'completed',
      type: 'jobs:request',
      updatedAt: '2024-08-23T17:02:40.000+02:00',

      data: {
        domains: ['united.com'],
        job: 'enrich-companies',
      },
    },
  ],
  meta: {
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 10,
    total: 2,
  },
}

const responseAttributes = computed((): ApiAttribute[] => {
  return [
    {
      attributes: getActionAttributes(),
      description: t('response.actions'),
      name: 'actions',
      type: 'array',
    },
    getMetaAttributes(),
  ]
})
</script>

<template>
  <ApiDoc
    :endpoints="endpoints"
    :level-to-open="2"
    :query-attributes="queryAttributes"
    :response="response"
    :response-attributes="responseAttributes"
  />
</template>

<i18n lang="json">
{
  "en": {
    "attributes": {
      "full": "Whether to fetch the full action details.",
      "ids": "The IDs of the actions to fetch.",
      "listId": "The ID of the list to fetch actions for.",
      "page": "The page to fetch (default to 1).",
      "size": "The number of actions to be returned (between 1 and 25). Default to 10.",
      "status": "The status of the actions to retrieve."
    },
    "response": {
      "actions": "The list of actions."
    }
  },
  "es": {
    "attributes": {
      "full": "Si se deben obtener los detalles completos de la acción.",
      "ids": "Los IDs de las acciones a obtener.",
      "listId": "El ID de la lista para la que se obtendrán las acciones.",
      "page": "La página a recuperar (por defecto es 1).",
      "size": "El número de acciones que se devolverán (entre 1 y 25). Por defecto es 10.",
      "status": "El estado de las acciones a recuperar."
    },
    "response": {
      "actions": "La lista de acciones."
    }
  },
  "fr": {
    "attributes": {
      "full": "Si l'on doit récupérer les détails complets de l'action.",
      "ids": "Les IDs des actions à récupérer.",
      "listId": "L'ID de la liste pour laquelle récupérer les actions.",
      "page": "La page à récupérer (par défaut 1).",
      "size": "Le nombre d'actions à retourner (entre 1 et 25). Par défaut à 10.",
      "status": "Le statut des actions à récupérer."
    },
    "response": {
      "actions": "La liste des actions."
    }
  }
}
</i18n>
